interface Props {
  to: string;
}

function Redirect({ to }: Props) {
  window.location.replace(to);
  return null;
}

export default Redirect;
